export interface USPIDetectionResult {
  isUSPI: boolean;
  missingRequiredSections: string[];
  hasHighlightsHeader: boolean;
}

const REQUIRED_USPI_SECTIONS = [
  "Indications and Usage",
  "Dosage and Administration",
  "Dosage Forms and Strengths",
  "Contraindications",
  "Warnings and Precautions",
  "Adverse Reactions",
  "Drug Interactions",
  "Use in Specific Populations",
  "Overdosage",
  "Description",
  "Clinical Pharmacology",
  "Nonclinical Toxicology",
  "Clinical Studies",
  "How Supplied",
  "Storage and Handling",
  "Patient Counseling Information"
];

export async function detectUSPIDocument(): Promise<USPIDetectionResult> {
  return await Word.run(async (context) => {
    const body = context.document.body;
    body.load("text");
    await context.sync();

    const documentText = body.text.toLowerCase();
    const trimmedText = documentText.trim();
    
    // Check if document starts with HIGHLIGHTS OF PRESCRIBING INFORMATION
    const hasHighlightsHeader =
      trimmedText.startsWith("highlights of prescribing information");

    const missingRequiredSections: string[] = [];
    let foundSections = 0;

    for (const section of REQUIRED_USPI_SECTIONS) {
      const sectionLower = section.toLowerCase();
      if (documentText.includes(sectionLower)) {
        foundSections++;
      } else {
        missingRequiredSections.push(section);
      }
    }
    
    // Determine if document has atleast 10 required sections
    const isUSPI = hasHighlightsHeader && foundSections >= 10;

    return {
      isUSPI,
      missingRequiredSections,
      hasHighlightsHeader
    };
  });
}